import React from "react";
import { AlertTriangle, Scale } from "lucide-react";
import { cn } from "@/lib/utils";

export const DISCLAIMER_TEXT =
  "This library is provided for educational and informational purposes only and does not constitute legal advice. Laws and contractual requirements vary by jurisdiction, transaction, company structure, and circumstances. Have important agreements reviewed by a qualified attorney before signing or relying upon them.";

export const TEMPLATE_DISCLAIMER_TEXT =
  "IMPORTANT: This template is provided for educational and informational purposes only and does not constitute legal advice. Laws and contractual requirements vary by jurisdiction, transaction, company structure, and circumstances. Founders should have important agreements reviewed by a qualified attorney before signing or relying upon them.";

/**
 * The disclaimer. Shown on the dashboard, on every document entry and above every template.
 * `variant="template"` uses the longer wording that also prints at the top of a rendered document.
 */
export default function LegalDisclaimer({ variant = "library", className }) {
  const isTemplate = variant === "template";
  const Icon = isTemplate ? AlertTriangle : Scale;
  return (
    <div
      role="note"
      className={cn(
        "flex gap-3 rounded-lg border p-3.5 text-xs leading-relaxed",
        isTemplate ? "border-pink-300 bg-pink-50 text-pink-900" : "border-sky-300 bg-sky-100 text-sky-900",
        className,
      )}
    >
      <Icon className={cn("mt-0.5 h-4 w-4 shrink-0", isTemplate ? "text-pink-600" : "text-sky-700")} />
      <p>{isTemplate ? TEMPLATE_DISCLAIMER_TEXT : DISCLAIMER_TEXT}</p>
    </div>
  );
}

/** A compact inline variant for use inside cards. */
export function AttorneyBadgeNote({ level, note, className }) {
  if (!level) return null;
  const strong = level === "strongly-recommended";
  return (
    <div
      className={cn(
        "flex gap-2 rounded-md border px-3 py-2 text-xs",
        strong ? "border-red-200 bg-red-50 text-red-900" : "border-pink-200 bg-pink-50 text-pink-900",
        className,
      )}
    >
      <AlertTriangle className={cn("mt-0.5 h-3.5 w-3.5 shrink-0", strong ? "text-red-600" : "text-pink-600")} />
      <span>
        <strong className="font-semibold">
          {strong ? "Attorney involvement strongly recommended." : "Attorney review recommended."}
        </strong>{" "}
        {note}
      </span>
    </div>
  );
}
